import './styles/index.css';
import { mockMode } from './lib/api.js';
import { setNavigator } from './lib/nav.js';
import { createRouter } from './router.js';
import { notFound, routes } from './routes.js';

mockMode(); // persist ?mock=… for this tab before any navigation drops the query

const outlet = document.getElementById('app');
if (!outlet) throw new Error('#app missing');
const router = createRouter(outlet, routes, notFound);
setNavigator((to, opts) => {
  router.navigate(to, opts);
  window.scrollTo({ top: 0 });
});
router.start();
